import { Injectable } from '@angular/core';
import { System } from '../../shared-components/System';
import { HttpClient } from '@angular/common/http';
import { YearService } from '../../shared-components/year/year.service';
import { MassEmailStudent, Recipient } from './mass-email.model';
import { Observable } from 'rxjs';

@Injectable()
export class MassEmailService {
  isBackClick = false;

  constructor(
    private http: HttpClient,
    private yearService: YearService
  ) { }

  getStudentsByClass(subjectSectionIds: number[], yearId: number, schoolId: number) {
    let queryString = '';
    queryString += '?yearId=' + yearId +
      '&schoolId=' + schoolId;
    return this.http.post<any[]>(System.apiURL.Student + 'GetStudentsByClass' + queryString, subjectSectionIds);
  }

  getStudentsByTeams(studentTeamIds: number[], yearId: number, schoolId: number) {
    let queryString = '';
    queryString += '?yearId=' + yearId +
      '&schoolId=' + schoolId;
    return this.http.post<any[]>(System.apiURL.Student + 'GetStudentsByTeams' + queryString, studentTeamIds);
  }

  getStudentsByLists(studentListIds: number[], yearId: number, schoolId: number) {
    let queryString = '';
    queryString += '?yearId=' + yearId +
      '&schoolId=' + schoolId;
    return this.http.post<any[]>(System.apiURL.Student + 'GetStudentsByLists' + queryString, studentListIds);
  }  

  getParentTypes(yearId: number) {
    let queryString = '';
    queryString += '?yearId=' + yearId;
    return this.http.get<any[]>(System.apiURL.Student + 'GetParentTypes' + queryString);
  }
  getTeacherRecipientsForMassEmail(sectionIds) {
    return this.http.post<Recipient[]>(System.apiURL.Student + 'GetTeacherRecipientsForMassEmail', sectionIds);
  }
  GetTeamStaffMemberRecipientsForMassEmail(sectionIds: number[], yearId: number, schoolId: number) {
    let queryString = '';
    queryString += '?yearId=' + yearId +
      '&schoolId=' + schoolId;
    return this.http.post<Recipient[]>(System.apiURL.Student + 'GetTeamStaffMemberRecipientsForMassEmail' + queryString, sectionIds);
  }

  sendMassEmail(email, isBodyHtml, area, schoolId, yearId) {
    let queryString = '';
    queryString += '?isBodyHtml=' + isBodyHtml +
      '&area=' + area +
      '&schoolId=' + schoolId +
      '&yearId=' + yearId;
    System.removeIdFields(email);
    return this.http.post<any[]>(System.apiURL.Student + 'SendMassEmail' + queryString, email);
  }

  getStudentInfoForMassEmail(studentIds: number[], yearId: number, schoolId: number): Observable<MassEmailStudent[]> {
    let queryString = '';
    queryString += '?yearId=' + yearId +
      '&schoolId=' + schoolId;

    return this.http.post<MassEmailStudent[]>(System.apiURL.Student + 'GetStudentInfoForMassEmail' + queryString, studentIds);
  }
}
